<template>
	<div class="id">
		<van-nav-bar :title="columns.name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="waterfall-container">
			<div class="item-content">{{columns.name}}</div>
			<div class="waterfall-column" v-for="(column, index) in columns.images" :key="index">
				<img :src="column" />
			</div>
			<div class="btn" @click="contact">{{$t("other.contact")}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				columns: {},
				id: this.$route.query.id,
			};
		},
		created() {
			this.getBeautyInfo()
		},
		computed: {

		},
		methods: {
			back() {
				return window.history.back();
			},
			contact(){
				this.$http({
					method: "post",
					url: "submit",
					data: {
						beauty_id: this.id
					}
				}).then((res) => {
					if (res.code == 1) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				});
			},
			getBeautyInfo() {
				this.$http({
					method: "get",
					url: "getBeautyInfo",
					data: {
						beauty_id: this.id
					}
				}).then((res) => {
					if (res.code == 1) {
						console.log(res.data)
						this.columns = res.data;
					} else {
						this.$toast(res.msg);
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.id {
		min-height: 100vh;
		background-color: #f2f2f5;
	}

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
		margin-bottom: 20px;
	}

	.waterfall-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 20px;
		overflow-y: scroll;
		height: calc(100vh - 140px);
	}

	.waterfall-column {
		width: 100%;
		margin-bottom: 20px;

		img {
			width: 100%;
			display: block;
			border-radius: 10px;
			object-fit: contain;
		}
	}

	.btn {
		color: white;
		background: linear-gradient(to right, rgb(127, 87, 120), rgb(229, 194, 160));
		border-radius: 20px;
		padding: 20px 200px;
		margin-bottom: 100px;
		margin-top: 40px;
	}

	.item-content {
		padding: 20px;
		font-size: 34px;
	}
</style>